import client from './api';

// Sponsorluk şeridi beş kabuğun da footer'ında çizilir. Kabuk değişince
// bileşen yeniden bağlanır; istek her seferinde tekrarlanmasın diye yanıt
// modül belleğinde tutulur (aynı sekmede tek çağrı).
let cache = null;
let inflight = null;

export const SPONSORSHIP_TIER_LABELS = {
  main: 'ANA SPONSOR',
  shirt: 'FORMA SPONSORU',
  sleeve: 'KOL SPONSORU',
  regional: 'BÖLGESEL SPONSOR',
  official: 'RESMİ SPONSOR',
  partner: 'RESMİ İŞ ORTAĞI',
};

export const SPONSORSHIP_TYPE_LABELS = {
  club: 'Kulüp',
  league: 'Lig',
  athlete: 'Sporcu',
  event: 'Etkinlik',
  other: 'Diğer',
};

// Etiket sunucudan da gelir (`tier_label`); burada yalnızca yedek vardır —
// iki yerin ayrışmaması için önce sunucunun değeri kullanılır.
export const sponsorshipTierLabel = (item) => (
  item?.tier_label || SPONSORSHIP_TIER_LABELS[item?.tier] || 'RESMİ SPONSOR'
);

export const sponsorshipTypeLabel = (item) => (
  item?.type_label || SPONSORSHIP_TYPE_LABELS[item?.partner_type] || ''
);

export const fetchSponsorships = async () => {
  if (cache) return cache;
  if (!inflight) {
    inflight = client.get('/sponsorships')
      .then(({ data }) => {
        cache = Array.isArray(data?.items) ? data.items : [];
        return cache;
      })
      .catch(() => {
        // Sponsorluk şeridi süstür: uç kapalıysa (lisans kilidi, ağ hatası)
        // footer sessizce şeritsiz çizilir, hata gösterilmez.
        cache = [];
        return cache;
      })
      .finally(() => { inflight = null; });
  }
  return inflight;
};

export const resetSponsorshipCache = () => {
  cache = null;
  inflight = null;
};

export default fetchSponsorships;
